<template>
  <div>
    <el-dialog
      :visible.sync="newDialog"
      center
      :close-on-click-modal="true"
      @close="closeDialog"
      class="dialog_modal dialog_800"
      :append-to-body="true"
    >
      <div class="dialog_content">
        <div class="flex_center margin-bottom20">
          <img
            class="dialog_update_img"
            src="../../../../assets/dialogIcoImg/huokeUpdateOne.png"
            alt=""
          />
        </div>

        <h3 class="dialog_normal_question-head margin-bottom20">
          Update for more recommendations
        </h3>
        <div class="detail_cont">
          <div class="Exportoffline">
            <div
              class="detail_cont_text"
              style="padding: 0px; margin-top: 0px !important"
            >
              <h5 class="margin-bottom20">
                For more details and/or recommendations about your potential
                customers or vendors, you can select the following options:
              </h5>
              <div class="ExportCheckbook">
                <el-radio v-model="Updatechecked" label="1"
                  >Order comprehensive reports</el-radio
                >
              </div>
              <div class="ExportCheckbook-text">
                This comprehensive report will encompass all the necessary
                background information, including detailed contact details,
                trade records, a business description, company performance,
                credit rating and more.
              </div>
              <div class="ExportCheckbook">
                <el-radio v-model="Updatechecked" label="2" :disabled="true"
                  >Contact the selected companies (Coming soon...)
                </el-radio>
              </div>
              <div class="ExportCheckbook-text">
                This service offers a list of multiple valid email addresses for
                your target companies. You can use these addresses to send
                inquiries to the target companies via email. Once the target
                companies respond to your inquiries, the valid contact
                information will be established.
              </div>
              <div class="ExportCheckbook">
                <el-radio v-model="Updatechecked" label="3"
                  >Generate more leads</el-radio
                >
              </div>
              <div class="ExportCheckbook-text">
                This service provides more information about potential customers
                or vendors that align with your requirements. You have the
                flexibility to select the number of companies, the frequency of
                the reports, and the preferred method of receiving them.
              </div>
            </div>
            <div>
              <!-- <h3>Please select the type of offline report to update :</h3> -->
              <!-- <div class="ExportCheckbook">
                            <el-checkbox v-model="Updatechecked">Update existing offline reports</el-checkbox>
                        </div>
                        <div class="ExportCheckbook">
                            <el-checkbox v-model="reportschecked">Download offline reports with precise
                                data</el-checkbox>

                        </div> -->
            </div>
          </div>
        </div>

        <div class="flex_center margin-top20">
          <el-button
            class="btn_export riskButton riskButton"
            style="
              background-color: #e7e5ff !important;
              color: #8e86dd !important;
            "
            @click="closeDialog()"
            >Cancel</el-button
          >
          <el-button
            class="btn_export riskButton riskButton margin-left30"
            :class="
              false ? 'questionExportButton' : 'questionExportButtonactive'
            "
            @click="UpdateNext()"
            >Next</el-button
          >
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="UpdateEndDialog"
      center
      :close-on-click-modal="true"
      @close="UpdatecloseDialog"
      class="dialog_modal dialog_800"
      :append-to-body="true"
    >
      <div class="dialog_content">
        <div class="flex_center margin-bottom20">
          <img
            class="dialog_update_img"
            src="../../../../assets/dialogIcoImg/huokeUpdate.png"
            alt=""
          />
        </div>
        <h3 class="dialog_normal_question-head">Order comprehensive reports</h3>
        <div class="detail_cont">
          <div class="ExportCheckbook-center margin-top20 margin-bottom30">
            Upon placing your order for comprehensive reports, your order will
            initiate offline research and investigation. Each company will be
            charged {{ HuokeDetailPoint }} credits for this order. Your reports
            will typically be delivered to your account within 72 hours. Please
            check your email notification for the details.
          </div>
        </div>
        <div class="flex_center">
          <el-button
            class="btn_export questionExportButtonactive riskButton"
            @click="UpdatecloseDialog()"
            >Back</el-button
          >
          <!-- <el-button class="btn_export riskButton" @click="UpdateEndDialog = false; closeDialog()"
                    style="background-color: #E7E5FF !important; color: #8E86DD !important;margin-left: 30px;">Cancel</el-button> -->

          <el-button
            class="btn_export questionExportButtonactive riskButton margin-left30"
            @click="ConfirmUndate()"
            >Order now</el-button
          >
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="uPdateDialog"
      center
      :close-on-click-modal="true"
      @close="uPdatecloseDialog"
      class="dialog_modal dialog_800"
      :append-to-body="true"
    >
      <div class="dialog_content">
        <div class="flex_center margin-bottom20">
          <img
            class="dialog_update_img"
            src="../../../../assets/dialogIcoImg/huokeUpdateOne.png"
            alt=""
          />
        </div>
        <h3 class="dialog_normal_question-head">Update</h3>
        <div class="detail_cont">
          <div class="ExportCheckbook-center margin-top10">
            You need to deduct {{ HuokeDetailPoint }} credits when “Update
            existing offline reports “. Click “ Update now “ to continue update
          </div>
        </div>
        <div class="flex_center margin-top30">
          <el-button
            class="btn_export questionExportButtonactive riskButton"
            @click="onSubmitkoudian()"
            >Update now</el-button
          >
          <el-button
            class="btn_export questionExportButtonactive riskButton margin-left30"
            @click="onSubmitquxiao()"
            >Add Credits</el-button
          >
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="UpdateEndDialogtree"
      center
      :close-on-click-modal="true"
      @close="UpdatecloseDialogtree"
      class="dialog_modal dialog_800"
      :append-to-body="true"
    >
      <div class="dialog_from_content">
        <div class="flex_center margin-bottom20">
          <img
            class="dialog_update_img"
            src="../../../../assets/dialogIcoImg/huokeUpdatetwo.png"
            alt=""
          />
        </div>
        <h3 class="dialog_normal_question-head">Generate more leads</h3>
        <div class="detail_cont">
          <div class="detail_cont_texttwo flex_box">
            <div class="dialog_gen_lab">Recommended target number:</div>
            <div class="dialog_gen_select">
              <el-select
                :popper-append-to-body="false"
                style="width: 100%"
                v-model="NumberValue"
                placeholder="Please select the Recommended target number"
              >
                <el-option
                  v-for="item in NumberValueList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="detail_cont_texttwo flex_box">
            <div class="dialog_gen_lab">Recommended frequency:</div>
            <div class="dialog_gen_select">
              <el-select
                style="width: 100%"
                :popper-append-to-body="false"
                v-model="frequeryListvalue"
                @change="SelectQuerlsit()"
                placeholder="Please select the recommended frequency"
              >
                <el-option
                  v-for="item in frequeryList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="detail_cont_texttwo flex_box" v-if="isSelectduoxuan">
            <div class="dialog_gen_lab">Recommended deadline:</div>
            <div class="dialog_gen_select">
              <el-select
                :popper-append-to-body="false"
                style="width: 100%"
                v-model="duxuanvaluetwo"
                placeholder="Please select the deadline for advancement"
              >
                <el-option
                  v-for="item in duoxuanList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <!-- <el-cascader
                            :popper-append-to-body="false"
                            :append-to-body="true"
                            style="width: 100%;"
                            :options="options"
                            :props="props"
                            clearable></el-cascader> -->
            </div>
          </div>
          <div class="detail_cont_texttwo flex_box">
            <div class="dialog_gen_lab">Recommended content:</div>
            <div class="dialog_gen_select">
              <el-select
                style="width: 100%"
                :popper-append-to-body="false"
                multiple
                v-model="duxuanvalue"
                placeholder="Please select recommended content"
              >
                <el-option
                  v-for="item in duoxuanListone"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <!-- <el-cascader
                            :popper-append-to-body="false"
                            :append-to-body="true"
                            style="width: 100%;"
                            :options="options"
                            :props="props"
                            clearable></el-cascader> -->
            </div>
          </div>
        </div>
        <div class="flex_center margin-top30">
          <el-button
            class="riskButton btn_export questionExportButtonactive"
            @click="UpdatecloseDialogtree()"
            >Back</el-button
          >
          <el-button
            class="btn_export riskButton margin-left30"
            @click="UpdatecloseDialogtree()"
            style="
              background-color: #e7e5ff !important;
              color: #8e86dd !important;
            "
            >Cancel</el-button
          >
          <a
            class="flex_center margin-left30"
            :href="
              'mailto:service@csibizinfo.com?subject=Generate more leadst&body=UserID: ' +
              userinfo?.userInfo.email +
              '%0Aand recommended target number:' +
              NumberValue +
              '%0Arecommended frequency:' +
              frequeryListvalue +
              '%0Arecommended deadline:' +
              duxuanvaluetwo +
              '%0Arecommended content:' +
              duxuanvalue
            "
          >
            <el-button
              class="btn_export questionExportButtonactive riskButton"
              @click="UpdatecloseDialogtree()"
              >Confirm</el-button
            >
          </a>
        </div>
      </div>
    </el-dialog>

    <ShowCompany
      :suoClose="ShowCompanySuo"
      @closeSaveDialog="ShowCompanyDialog($event)"
    ></ShowCompany>
    <ShowCompanytwo
      :suoClose="ShowCompanySuotwo"
      @closeSaveDialogtwo="ShowCompanyDialogtwo($event)"
    >
    </ShowCompanytwo>
  </div>
</template>

<script>
import { saveUserConsumptionBatch, getPointAndHour } from "@/api/userApi";
import ShowCompany from "./ShowCompany.vue";
import ShowCompanytwo from "./ShowCompanytwo.vue";
import { getUserSimpleInfo } from "@/api/companyApi.js";
export default {
  props: {
    suoClose: {
      type: Boolean,
      //   default: false,
    },
    obj: {
      type: Object,
    },
    update: {
      type: Object,
    },
    ComapnyName: {
      type: String,
    },
  },
  components: {
    ShowCompany,
    ShowCompanytwo,
  },

  data() {
    return {
      UpdateEndDialog: false,
      frequeryListvalue: "One time",
      Updatechecked: "1",
      reportschecked: true,
      isSelectduoxuan: false,
      HuokeDetailPoint: 0,
      duxuanvalue: "",
      duxuanvaluetwo: "",
      userinfo: JSON.parse(localStorage.getItem("userInfo")),
      frequeryList: [
        {
          value: "One time",
          label: "One time",
        },
        {
          value: "Monthly",
          label: "Monthly",
        },
        {
          value: "Quarterly",
          label: "Quarterly",
        },
      ],
      RecommendedList: [
        {
          value: "Company Name",
          label: "Company Name",
        },
        {
          value: "Monthly",
          label: "Monthly",
        },
        {
          value: "Quarterly",
          label: "Quarterly",
        },
      ],
      props: { multiple: true },
      options: [
        {
          value: 1,
          label: "Company Name",
        },
        {
          value: 17,
          label: "Company Profile",
        },
      ],
      //page: this.currentPage
      uPdateDialog: false,
      ShowCompanySuo: false,
      ShowCompanySuotwo: false,
      UpdateEndDialogtree: false,
      lastUpdateList: [],
      NumberValue: "5",
      NowUpdateList: [],

      NumberValueList: [
        {
          value: "5",
          label: "5",
        },
        {
          value: "10",
          label: "10",
        },
        {
          value: "15",
          label: "15",
        },
        {
          value: "20",
          label: "20",
        },
      ],
      duoxuanList: [
        {
          value: "3months",
          label: "3 months",
        },
        {
          value: "6months",
          label: "6 months",
        },
        {
          value: "9months",
          label: "9 months",
        },
        {
          value: "1year",
          label: "1 year",
        },
      ],
      duoxuanListone: [
        {
          value: "CompanyName",
          label: "Company Name",
        },
        {
          value: "CompanyProfile",
          label: "Company Profile",
        },
        {
          value: "Contactinfo",
          label: "Contact info",
        },
        {
          value: "CompanyCreditReport",
          label: "Company Credit Report",
        },
      ],

      token: sessionStorage.getItem("token"),
    };
  },
  computed: {
    newDialog: {
      get() {
        return this.suoClose;
      },
      set() {},
    },
  },
  destroyed() {
    // bus.$off('handleShowLogin');
  },
  methods: {
    UpdateHuokePoint() {
      this.UpdateEndDialog = true;
      let UpdatePoint = [];

      this.$store.state.app.changeList.map((item) => {
        UpdatePoint.push({
          countryCode: item.company_country,
          companyName: item.company_name_en,
          companyAaaid: item.aaa_id,
        });
      });
      getPointAndHour(UpdatePoint).then((res) => {
        if (res.code == 200) {
          this.HuokeDetailPoint = res.data.point;
        }
      });
    },

    SelectQuerlsit(val) {
      if (this.frequeryListvalue == "Monthly") {
        this.isSelectduoxuan = true;
        this.duxuanvaluetwo = "";
        this.duoxuanList = [
          {
            value: "3months",
            label: "3 months",
          },
          {
            value: "6months",
            label: "6 months",
          },
          {
            value: "9months",
            label: "9 months",
          },
          {
            value: "1year",
            label: "1 year",
          },
        ];
      } else if (this.frequeryListvalue == "Quarterly") {
        this.duxuanvaluetwo = "";
        this.isSelectduoxuan = true;
        this.duoxuanList = [
          {
            value: "2",
            label: "2",
          },
          {
            value: "3",
            label: "3",
          },
          {
            value: "4",
            label: "4",
          },
        ];
      } else {
        this.isSelectduoxuan = false;
      }
    },
    UpdateNext() {
      if (this.Updatechecked == "1") {
        this.UpdateHuokePoint();
      } else if (this.Updatechecked == "2") {
        this.ShowCompanySuotwo = true;
      } else {
        this.UpdateEndDialogtree = true;
      }
    },
    ConfirmUndate() {
      if (this.Updatechecked && !this.reportschecked) {
        this.confirmClick();
      }
      if (this.reportschecked) {
        this.uPdateDialog = true;
        // this.ShowCompanySuo = true
      }
    },
    confirmClick() {
      const recipient = "service@csibizinfo.com"; // 收件人邮箱
      const subject = "Dear customer, hello:"; // 邮件主题
      const body =
        "I hope to receive more customer offline reports. Can sales contact me to discuss and obtain the necessary information. "; // 邮件内容
      const mailtoLink = `mailto:${recipient}?subject=${encodeURIComponent(
        subject,
      )}&body=${encodeURIComponent(body)}`;
      window.location.href = mailtoLink; // 调起邮箱
    },
    PreviousStep() {},
    ShowCompanyDialog(value) {
      this.ShowCompanySuo = value;
    },
    ShowCompanyDialogtwo(value) {
      this.ShowCompanySuotwo = value;
    },
    uPdatecloseDialog() {
      this.uPdateDialog = false;
    },
    UpdatecloseDialog() {
      this.UpdateEndDialog = false;
    },
    UpdatecloseDialogtree() {
      this.UpdateEndDialogtree = false;
    },
    //关闭弹窗
    closeDialog() {
      this.$emit("closeExportDialog", false);
    },
    onSubmitkoudian() {
      let Updatelis = [];

      this.$store.state.app.changeList.map((item) => {
        Updatelis.push({
          countryCode: item.company_country,
          companyName: item.company_name_en,
          companyAaaid: item.aaa_id,
        });
      });
      saveUserConsumptionBatch(Updatelis).then((res) => {
        let that = this;
        if (res.code == 200) {
          res.data.map((item) => {
            if (item.consumptionStatus == 1) {
              that.lastUpdateList.push(item.consumptionPoints);
            }
            if (item.consumptionStatus == 2) {
              that.NowUpdateList.push(item.consumptionPoints);
            }
          });

          this.$message({
            message: res.msg,
            type: "success",
          });
          getUserSimpleInfo().then((res) => {
            if (res.code == 200) {
              this.$store.dispatch(
                "app/setEquityType",
                res.data.availablePoints,
              );
            }
          });
          this.newDialog = false;
          this.UpdateEndDialog = false;

          if (this.Updatechecked) {
            this.confirmClick();
          }
          this.uPdateDialog = false;
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      });
    },
    onSubmitquxiao() {
      this.$router.push({
        path: "/index/addCredit",
      });
    },
  },
};
</script>
<style scoped>
.detail_cont {
  overflow: auto;
}

.Exportoffline {
  background: #f5f5f5;
  border-radius: 6px;
  padding: 20px;
  margin-top: 10px;
  font-size: 20px;
  color: #1a2332;
  line-height: 26px;
}

.questionExportButton {
  background: #eeeeee !important;
  font-size: 20px;
  color: #999999;
  margin-left: 20px;
}
.detail_cont_texttwo {
  font-size: 20px;
  color: #1a2332;
  margin-top: 20px;
  word-break: keep-all;
  text-align: justify;
}

::v-deep .el-input__inner {
  font-size: 20px;
  border: 1px solid #cccccc;
}

::v-deep .el-radio__input.is-checked .el-radio__inner {
  /* background-color: #ED8850 !important; */
  border-color: #8e86dd !important;
}

::v-deep .el-radio__input.is-checked .el-radio__inner::after {
  border-color: #8e86dd !important;
}

::v-deep .el-radio__input.is-checked .el-radio__inner::after {
  background-color: #8e86dd !important;
}

::v-deep .el-radio__inner:hover {
  border-color: #8e86dd !important;
  /* border-color: #409EFF; */
}
::v-deep .el-radio {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

::v-deep .el-radio__label {
  font-family: "Arial Bold";
}
::v-deep .el-select-dropdown__item.selected {
  color: #8e86dd !important;
}

.ExportCheckbook-text {
  font-size: 20px;
  color: #666666;
  padding-left: 27px;
  margin: 14px 0 20px;
}

.ExportCheckbook-center {
  font-size: 20px;
  text-align: center;
  color: #1a2332;
  line-height: 26px;
}

.dialog_update_img {
  width: 60px;
}
.dialog_from_content {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.dialog_gen_lab {
  width: 144px;
  margin-right: 10px;
}
.dialog_gen_select {
  flex: 1;
}
::v-deep .el-tag.el-tag--info {
  height: 40px;
  background: #ffffff;
  border-radius: 23px;
  border: 1px solid #cccccc;
  font-size: 18px;
  color: #1a2332;
  margin: 5px 10px 5px 0;
}
::v-deep .el-tag.el-tag--info .el-tag__close {
  background-color: #f56b6b;
  color: #ffffff;
}
::v-deep .el-select__tags {
  padding-left: 20px;
}
@media (max-width: 1920px) {
  .dialog_update_img {
    width: 45px;
  }
  .Exportoffline {
    border-radius: 5px;
    padding: 15px;
    margin-top: 7px;
    font-size: 16px;
    line-height: 20px;
  }
  .ExportCheckbook-text,
  .ExportCheckbook-center {
    font-size: 16px;
    line-height: 20px;
  }
  .ExportCheckbook-text {
    margin: 10px 0 15px;
  }
  .questionExportButton {
    font-size: 16px;
    margin-left: 15px;
  }
  .detail_cont_texttwo {
    font-size: 16px;
    margin-top: 15px;
  }
  .dialog_gen_lab {
    width: 114px;
    margin-right: 7px;
  }
  ::v-deep .el-input__inner {
    font-size: 16px;
  }
  ::v-deep .el-tag.el-tag--info {
    height: 32px;
    border-radius: 18px;
    font-size: 16px;
    margin: 4px 7px 3px 0;
  }
  ::v-deep .el-select__tags {
    padding-left: 15px;
  }
}
@media (max-width: 1439px) {
  .dialog_update_img {
    width: 40px;
  }
  .Exportoffline {
    border-radius: 4px;
    padding: 12px;
    margin-top: 6px;
    font-size: 14px;
    line-height: 18px;
  }
  .ExportCheckbook-text,
  .ExportCheckbook-center {
    font-size: 14px;
    line-height: 18px;
  }
  .ExportCheckbook-text {
    margin: 8px 0 12px;
  }
  .questionExportButton {
    font-size: 14px;
    margin-left: 12px;
  }
  .detail_cont_texttwo {
    font-size: 14px;
    margin-top: 12px;
  }
  .dialog_gen_lab {
    margin-right: 6px;
  }
  ::v-deep .el-input__inner {
    font-size: 14px;
  }
  ::v-deep .el-tag.el-tag--info {
    height: 30px;
    border-radius: 16px;
    font-size: 14px;
    margin: 3px 6px 3px 0;
  }
  ::v-deep .el-select__tags {
    padding-left: 12px;
  }
}
</style>
